import React, { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

const MainHeader = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  // Handle body scroll locking based on menu state
  useEffect(() => {
    if (isMenuOpen) {
      document.body.classList.add('lock-scroll');
    } else {
      document.body.classList.remove('lock-scroll');
    }

    return () => {
      document.body.classList.remove('lock-scroll'); // Cleanup on unmount
    };
  }, [isMenuOpen]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenuAndScroll = () => {
    setIsMenuOpen(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  useEffect(() => {
    let resizeTimer;
    const handleResize = () => {
      document.body.classList.add('resize-animation-stopper');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove('resize-animation-stopper');
      }, 400);

      // Auto-close menu if resized to desktop
      if (window.innerWidth > 991 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isMenuOpen]);

  useEffect(() => {
    const header = document.querySelector('.header');
    const headerTop = document.querySelector('.header-top');
    const headerTopHeight = headerTop?.offsetHeight || 0;

    function updateHeader() {
      if (window.scrollY >= headerTopHeight) {
        header.classList.add('fixed-top');
      } else {
        header.classList.remove('fixed-top');
      }
    }

    updateHeader();
    window.addEventListener('scroll', updateHeader);

    return () => {
      window.removeEventListener('scroll', updateHeader);
    };
  }, []);

  return (
    <header className="header">
      <div className="container">
        <div className="nav__container">
          <div className="nav__mobile">
            <div className="nav__logo">
              <NavLink to="/" onClick={closeMenuAndScroll}>
                <img src="/Images/logo-white.png" alt="logo" />
              </NavLink>
            </div>
            <div className="nav__btn" onClick={toggleMenu}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a aria-label="Mobile menu" className={`nav-toggle ${isMenuOpen ? 'open' : ''}`}>
                <span></span>
                <span className="mrg"></span>
                <span className="mrg"></span>
              </a>
            </div>
          </div>
          <nav className={`menu-toggle ${isMenuOpen ? 'active' : ''}`}>
            <ul className="nav__menu">
              <li className={location.pathname === '/' ? 'active' : ''}>
                <NavLink exact="true" to="/" onClick={closeMenuAndScroll}>Home</NavLink>
              </li>
              <li className={location.pathname === '/about-us' ? 'active' : ''}>
                <NavLink to="/about-us" onClick={closeMenuAndScroll}>About</NavLink>
              </li>
              <li className={location.pathname === '/services' ? 'active' : ''}>
                <NavLink to="/services" onClick={closeMenuAndScroll}>Services</NavLink>
              </li>
              {/* TEMPORARILY HIDDEN
              <li className={location.pathname.startsWith('/programs') ? 'active' : ''}>
                <NavLink to="/programs/ai-powered-full-stack-developer" onClick={closeMenuAndScroll}>Programs</NavLink>
              </li>
              */}
              <li className={location.pathname === '/internship' ? 'active' : ''}>
                <NavLink to="/internship" onClick={closeMenuAndScroll}>Internship</NavLink>
              </li>
              <li className={location.pathname === '/contact-us' ? 'active' : ''}>
                <NavLink to="/contact-us" onClick={closeMenuAndScroll}>Contact</NavLink>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default MainHeader;
